import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { WorkSite, WorkSiteAssignee, WorkSitePage } from '../interfaces/workSite.interface';

// The backend caps Page<T> `size` at 100 (MAX_PAGE_SIZE) and silently truncates
// anything larger rather than erroring. Clamp here too so a caller passing a
// larger size gets an honest request instead of quietly losing rows server-side.
const MAX_PAGE_SIZE = 100;

export const WorkSiteService = {
    list: async (page = 0, size = 50): Promise<WorkSitePage> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.WORK_SITE.BY_INSTITUTION(institutionId), {
            params: { page, size: Math.min(size, MAX_PAGE_SIZE) },
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    create: async (site: WorkSite): Promise<WorkSite> => {
        const payload = { ...site, institutionId: AuthService.getSelectedInstitution()!! };
        const response = await axios.post(ENDPOINTS.WORK_SITE.BASE, payload, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    update: async (id: string, site: WorkSite): Promise<WorkSite> => {
        const payload = { ...site, institutionId: AuthService.getSelectedInstitution()!! };
        const response = await axios.put(ENDPOINTS.WORK_SITE.UPDATE(id), payload, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    remove: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.WORK_SITE.DELETE(id), { headers: AuthService.getAuthHeader() });
    },

    listAssignees: async (id: string): Promise<WorkSiteAssignee[]> => {
        const response = await axios.get(ENDPOINTS.WORK_SITE.EMPLOYEES(id), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    replaceAssignees: async (id: string, userIds: string[]): Promise<string[]> => {
        const response = await axios.put(
            ENDPOINTS.WORK_SITE.EMPLOYEES(id),
            { workSiteId: id, userIds },
            { headers: AuthService.getAuthHeader() },
        );
        return response.data;
    },
};
